(function Module() {
	'use strict';

	var validation = require('../../static/js/imported-parnell-common-modules').validation;

	mySynch.directive('validateEmail', [function validateEmail() {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function validateEmailLink(scope, elem, attrs, ngModel) {
				var modelWatchDeReg = undefined;
				modelWatchDeReg = scope.$watch(attrs.ngModel, function modelWatched(email) {
					if (email) {
						if (validation.isValidEmail(email)) {
							ngModel.$setValidity('email', true);
						} else {
							ngModel.$setValidity('email', false);
						}
					}
				});
				scope.$on('$destroy', function () {
					if (modelWatchDeReg) {
						modelWatchDeReg();
					}
				});
			}
		};
	}]);

	mySynch.directive('maxLength', function () {
		return  {
			restrict: 'A',
			scope: {
				maxLengthValue: '@'
			
			},
			link: function (scope, elm, attrs, ctrl) {
				elm.on('keyup', function (event) {
					var controlValue = _.get(event,'target.value');
                      if(controlValue.length > Number(scope.maxLengthValue)){
						_.set(event,'target.value',controlValue.substr(0,Number(scope.maxLengthValue)));
						event.preventDefault();  
						return false;
					  }
				});
			}
		};
	});
	mySynch.directive('onlyNumbers', function () {
		return  {
			restrict: 'A',
			link: function (scope, elm, attrs, ctrl) {
				elm.on('keydown', function (event) {

					if (event.shiftKey) {
						if (event.keyCode === 9) {
							return true;
						} else {
							event.preventDefault(); 
							return false;
						}
					}
					if ([8, 9, 13, 27, 37, 38, 39, 40, 46].indexOf(event.which) > -1) {
						// backspace, tab, enter, escape, arrows, del
						return true;
					} else if (event.which >= 48 && event.which <= 57) {
						// numbers 0 to 9
						return true;
					} else if (event.which >= 96 && event.which <= 105) {
						// numpad number
						return true;
					} 
					else if ([110, 190].indexOf(event.which) > -1) {
					    // dot and numpad dot
					    return true;
					}
					else {
						event.preventDefault();
						return false;
					}
				});
			}
		};
	});
	mySynch.directive('onlyNumbersStrict', function () {
		return  {
			restrict: 'A',
			link: function (scope, elm, attrs, ctrl) {
				elm.on('keydown', function (event) {

					if (event.shiftKey) {
						if (event.keyCode === 9) {
							return true;
						} else {
							event.preventDefault(); 
							return false;
						}
					}
					
					if ([8, 9, 13, 27, 37, 38, 39, 40, 46].indexOf(event.which) > -1) {
						// backspace, tab, enter, escape, arrows, del
						return true;
					} else if (event.which >= 48 && event.which <= 57) {
						// numbers 0 to 9
						return true;
					} else if (event.which >= 96 && event.which <= 105) {
						// numpad number
						return true;
					} 
					else if ([110, 190].indexOf(event.which) > -1) {
						// dot and numpad dot
						event.preventDefault();
					    return false;
					}
					else {
						event.preventDefault();
						return false;
					}
				});
			}
		};
	});

})();
